export const SETTINGS_KEY_PREFIX = 'settings'
export const FILTERS_KEY_PREFIX = 'filters'
export const NEWSLETTER_KEY_PREFIX = 'newsletter'
export const FEEDBACK_SURVEY_KEY_PREFIX = 'feedback-survey'
export const TUTORIAL_COMPLETION_CALLOUT_KEY_PREFIX = 'tutorial-completion-callout'
export const AB_TESTING_PREFIX = 'ab-testing'
export const PROFILE_SURVEY_KEY_PREFIX = 'profile-survey'
export const COUNTLY_PREFIX = 'countly'
